import script from "./Advertising.vue?vue&type=script&lang=ts&setup=true"
export * from "./Advertising.vue?vue&type=script&lang=ts&setup=true"

import "./Advertising.vue?vue&type=style&index=0&id=4f3559cc&lang=scss"

const __exports__ = script;

export default __exports__